import { ApiParameter, get, patch, post, request } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

// Interface change : Added two parameters: accountLTLAllowed, branchID ---- P21 Change
export interface GetShippingMethodsParams extends ApiParameter {
accountLTLAllowed: string;
branchID: string;
cannotShipAir: string;
carrierCodes : any
destinationCity : string;
destinationCountry : string;
destinationState : string;
destinationZipCode : string;
freightOptions : any;
hasBulkItem : boolean;
mustShipLTL : boolean;
orderTotal : number;
orderWeight : number;
overrideOriginCity : string;
overrideOriginCountry : string;
overrideOriginState : string;
overrideOriginZipCode: string;
overrideShipperID : string;
defaultCarrierCd: string;
getAllCarriers: boolean;
}

export interface ShippingMethodsResults {
    uri: any;
    shippingMethodHeader: ShippingMethodHeader;
    deliveryMethod: DeliveryMethod[];
    deliveryCarrier: DeliveryCarrier[];
    properties: Properties;
}

export interface ShippingMethodHeader {
    mustShipLTL: boolean;
    shippingWeight: number;
    totalCost: number;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    postalCode: string;
    cannotShipAir: string;
    accountLTLAllowed: string;
    orderMaterialTax: number;
    isCODCustomer: boolean;
    branchCode: string;
    branchPickupMaterialTax: number;
    returnCode81: string;
    productNeedsToBeRemoved: boolean;
}

export interface DeliveryMethod {
    p21FreightCode: string;
    car: string;
    cd: string;
    descr: string;
    def: string;
    freightCost: number;
    frieghtTax: number;
    isTBD: boolean;
}

export interface DeliveryCarrier {
    cd: string;
    def: string;
    desc: string;
    natAcc: string;
    thirdPartyOnFile: string;
}

export interface Properties { [key: string]: string };

// getP21ShippingMethods endpoint is the P21 change along with patch request ----- P21 Change
const shippingUrl = "/api/v1/shippingmethod/getP21ShippingMethods";

export async function getShippingMethods(parameter: GetShippingMethodsParams) {
   
    const response = await patch<ShippingMethodsResults>(
        shippingUrl,
        parameter as any,
    );
    return response;
}
